import { CheckCircle2Icon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { CategoryDeleteConfirmDialog } from './category-delete-confirm-dialog'
import { useCategoryList } from './use-category-list'

export interface CategoryListProps {
  onSuccessDeleteCategory: VoidFunction
}

export const CategoryList = ({ onSuccessDeleteCategory }: CategoryListProps) => {
  const {
    dataCategories,
    selectedCategoryIds,
    selectedCategories,
    isDeleteButtonDisabled,
    isDeleteConfirmDialogOpen,
    isDeleteCategoryPending,
    openDeleteConfirmDialog,
    closeDeleteConfirmDialog,
    toggleItem,
    handleConfirmDelete,
  } = useCategoryList({ onSuccessDeleteCategory })

  return (
    <>
      <div>
        <ul className={cn('w-full')}>
          {dataCategories?.map(({ _id, path_name }) => (
            <li key={_id}>
              <p className={cn('px-4 py-2')}>
                {/* Hidden checkbox */}
                <input
                  type="checkbox"
                  id={_id}
                  className={cn(
                    'absolute',
                    'peer',
                    'w-[1px]',
                    'h-[1px]',
                    '[clip-path:rect(1px_1px_1px_1px)]',
                    'overflow-hidden'
                  )}
                  onClick={() => toggleItem(_id)}
                />
                <label
                  htmlFor={_id}
                  className={cn(
                    'flex items-center',
                    'text-sm font-medium text-foreground',
                    'cursor-pointer',
                    'peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-blue-600'
                  )}
                >
                  <CheckCircle2Icon
                    size={20}
                    className={cn({
                      'fill-zinc-200 text-white': !selectedCategoryIds.has(_id),
                      'fill-blue-600 text-white': selectedCategoryIds.has(_id),
                    })}
                  />
                  <span className={cn('ml-2')}>{path_name}</span>
                </label>
              </p>
            </li>
          ))}
        </ul>
        <div
          className={cn(
            'flex items-center justify-between',
            'bg-elevated',
            'mt-[18px]',
            'px-6 py-2.5',
            'rounded-[9px]'
          )}
        >
          <p className={cn('text-sm font-medium text-[#0f172a]')}>
            {selectedCategoryIds.size} {`${selectedCategoryIds.size > 1 ? 'items' : 'item'}`} selected
          </p>
          <Button
            type="button"
            variant="destructive"
            disabled={isDeleteButtonDisabled}
            loading={isDeleteCategoryPending}
            onClick={openDeleteConfirmDialog}
          >
            Delete
          </Button>
        </div>
      </div>
      {isDeleteConfirmDialogOpen && (
        <CategoryDeleteConfirmDialog
          open={isDeleteConfirmDialogOpen}
          deletedCategories={selectedCategories}
          onClose={closeDeleteConfirmDialog}
          onConfirm={handleConfirmDelete}
        />
      )}
    </>
  )
}
